"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("./styles"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Col = ({
  className,
  ...props
}) => {
  className = className ? `rui-col ${className}` : 'rui-col';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.default, {
    className: className,
    ...props
  });
};

_styles.default.displayName = 'Col';
Col.propTypes = {
  col: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  xxs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  xs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_xxs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_xs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  offset_xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_xxs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_xs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  push_xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_xxs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_xs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  pull_xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_xxs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_xs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  order_xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  display: _propTypes.default.string,
  flex: _propTypes.default.string,
  alignItems: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = Col;
exports.default = _default;